/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agent_Schedule_Frequency_WeekdaysInputs */



/**
* | output |
* | --- |
* | "Every weekday (Mon to Fri)" |
*
* @param {Agent_Schedule_Frequency_WeekdaysInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const agent_schedule_frequency_weekdays = /** @type {((inputs?: Agent_Schedule_Frequency_WeekdaysInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Schedule_Frequency_WeekdaysInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Werktags (Mo. bis Fr.)")
	return /** @type {LocalizedString} */ ("Every weekday (Mon to Fri)")
});